export default __webpack_public_path__ + "static/media/151-industrial.fd0fad54.png";